var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 0C18.073 0 19.2939 0.505713 20.1941 1.40589C21.0943 2.30606 21.6 3.52696 21.6 4.8V16.8C21.6 18.073 21.0943 19.2939 20.1941 20.1941C19.2939 21.0943 18.073 21.6 16.8 21.6H4.8C3.52696 21.6 2.30606 21.0943 1.40589 20.1941C0.505713 19.2939 0 18.073 0 16.8V4.8C0 3.52696 0.505713 2.30606 1.40589 1.40589C2.30606 0.505713 3.52696 0 4.8 0H16.8ZM16.8 2.04H4.8C4.10054 2.03989 3.42713 2.30535 2.91589 2.78273C2.40466 3.2601 2.09375 3.91377 2.046 4.6116L2.04 4.8V16.8C2.03989 17.4995 2.30535 18.1729 2.78273 18.6841C3.2601 19.1953 3.91377 19.5063 4.6116 19.554L4.8 19.56H16.8C17.4995 19.5601 18.1729 19.2946 18.6841 18.8173C19.1953 18.3399 19.5063 17.6862 19.554 16.9884L19.56 16.8V4.8C19.5601 4.10054 19.2946 3.42713 18.8173 2.91589C18.3399 2.40466 17.6862 2.09375 16.9884 2.046L16.8 2.04Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCon);
export default __webpack_public_path__ + "static/media/checkbox_con.6e856e7b39cf9bdfc0f802490e34e838.svg";
export { ForwardRef as ReactComponent };